var SceneEvent = /** @class */ (function () {
    function SceneEvent(type, namespace, target, vars) {
        this.type = type;
        this.namespace = namespace;
        this.target = target;
        this.currentTarget = target;
        this.vars = vars;
        this.timestamp = Date.now();
    }
    return SceneEvent;
}());
export default SceneEvent;
//# sourceMappingURL=scene-event.js.map